import * as types from "./mutation-types";
import Services from "@/services";
export const loading = ({ commit }) => {
  commit(types.LOADING);
};

export const loaded = ({ commit }) => {
  commit(types.LOADED);
};

export const login = ({ commit }) => {
  commit(types.LOGIN);
};

export const logout = ({ commit }) => {
  commit(types.LOGOUT);
};

export const downloadLayout = ({ commit }, companyName) => {
  Services.getById("Configuration/GetLayout", companyName)
    .then(response => {
      commit(types.SETLAYOUT, response.data);
      commit(types.SETCONTRASTLAYOUT);
    })
    .catch(error => {
      console.log("Error while downloading layout", error);
    });
};

export const setKey = ({ commit }) => {
  commit(types.SETKEY);
};

export const setBaseFontSize = ({ commit }, size) => {
  commit(types.SETBASEFONTSIZE, size);
};

export const setContrast = ({ commit }, contrast) => {
  commit(types.SETCONTRASTLAYOUT, contrast);
};

export const setCompanyName = ({ commit }, companyName) => {
  commit(types.SET_COMPANY_NAME, companyName);
};
export const setLocales = ({ commit }, locales) => {
  commit(types.SET_LOCALES, locales);
};

export const pushLocales = ({ commit }, { company, locale }) => {
  commit(types.PUSH_LOCALES, { company, locale });
};

export const updateLocales = async ({ commit }, companyName) => {
  const { data } = await Services.get(
    "Locale/GetSimpleLocaleForCompany?companyName=" + companyName
  );
  var locales = { availableLangs: [] };
  data.forEach(item => {
    locales.availableLangs.push(item.tag);
    locales[item.tag] = {};
    item.translations.forEach(trans => {
      const splited = trans.key.trim().split(".");

      var temp = locales[item.tag.toLowerCase()];

      splited.slice(0, -1).forEach(el => {
        if (temp[el.toLowerCase().trim()] == null) {
          temp[el.toLowerCase().trim()] = {};
        }
        temp = temp[el.toLowerCase().trim()];
      });

      temp[splited[splited.length - 1].toLowerCase().trim()] = trans.value;
    });
    locales[item.tag]["operation_names"] = item.operations;
    locales[item.tag]["queue_names"] = item.queues;
    locales[item.tag]["localization_names"] = item.localizations;
  });

  console.log(locales);
  commit(types.SET_LOCALES, locales);
};
